// Per-card slot-rarity overrides. Mirror of the server's
// valkenhall-server/scripts/rarity-overrides.js. The server is the
// authoritative source, this copy exists so the UI can display the
// correct shard price / disenchant refund without round-tripping.
//
// The Arthurian Legends Round Table knights (minus the named chase
// knights. Galahad, Gareth, Lancelot, Mordred, Pellinore, Yvain)
// are printed as Unique but pulled at the Elite rate; their shard
// price + disenchant value follow the pull rate, not the printed
// rarity. Cards not in this map use their printed rarity directly.
//
// Keep this in sync with the server file. If they drift, the shop
// will display one price while the server charges another.
const SLOT_RARITY_OVERRIDES = {
  'sorcery-sir_agravaine':         'Elite',
  'sorcery-sir_balin':             'Elite',
  'sorcery-sir_bedivere':          'Elite',
  'sorcery-sir_bors_the_younger':  'Elite',
  'sorcery-sir_gaheris':           'Elite',
  'sorcery-sir_gawain':            'Elite',
  'sorcery-sir_ironside':          'Elite',
  'sorcery-sir_kay':               'Elite',
  'sorcery-sir_lamorak':           'Elite',
  'sorcery-sir_morien':            'Elite',
  'sorcery-sir_pelleas':           'Elite',
  'sorcery-sir_perceval':          'Elite',
  'sorcery-sir_priamus':           'Elite',
  'sorcery-sir_tom_thumb':         'Elite',
  'sorcery-sir_tristan':           'Elite',
  'sorcery-dame_britomart':        'Elite',
};

// Returns the rarity that should drive pricing (shard cost + disenchant
// refund) for a given card. Falls back to the printed rarity when the
// card has no override.
export function slotRarityForCard(card) {
  if (!card) return null;
  return SLOT_RARITY_OVERRIDES[card.unique_id] || card.rarity || null;
}

// Same mapping keyed directly by cardId (the `sorcery-<slug>` form used in
// pack contents), for callers that hold a raw id rather than a card object.
// Drives pack re-roll / transmute eligibility, which must follow the
// distribution rarity (Elite for AL Unique-Knights), not the display stamp.
export function slotRarityForId(cardId, displayRarity) {
  return SLOT_RARITY_OVERRIDES[cardId] || displayRarity || null;
}
